import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/api";
import { Btn, Spinner } from "@/components/ui-kit";
import { EmptyState } from "@/components/dashboard-bits";
import { CreatorProfileView } from "@/components/CreatorProfileView";
import { ArrowLeft, MessageSquare } from "lucide-react";

export default function CreatorProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [creator, setCreator] = useState(undefined);

  useEffect(() => {
    let active = true;
    api.get(`/creators/${id}`)
      .then((r) => { if (active) setCreator(r.data); })
      .catch(() => { if (active) setCreator(null); });
    return () => { active = false; };
  }, [id]);

  if (creator === undefined) return <Spinner />;

  return (
    <div className="max-w-3xl mx-auto pb-16" data-testid="creator-profile-page">
      <button onClick={() => navigate(-1)} data-testid="back-button"
        className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-[#6E675C] hover:text-[#292827] transition-colors">
        <ArrowLeft size={16} /> Takaisin
      </button>

      {creator === null ? (
        <EmptyState title="Sisällöntuottajaa ei löytynyt" subtitle="Profiili ei ole saatavilla." />
      ) : (
        <>
          <CreatorProfileView creator={creator} />
          <div className="mt-12">
            <Btn className="w-full !py-4 !text-[16px] !rounded-2xl" onClick={() => navigate(`/dashboard/viestit?user=${creator.user_id}`)} data-testid="contact-creator-button">
              <MessageSquare size={18} /> Ota yhteyttä
            </Btn>
          </div>
        </>
      )}
    </div>
  );
}
